export default {
  campaigns: 'Campaigns',
  waves: 'Waves',
  events: 'Events',
  challenges: 'Challenges',
  wheel: 'Wheels',
  libraries: 'Libraries',
  banner: 'Banners',
  contests: 'Contests',
  advices: 'Advices',
  customers: 'Customers',
  settings: 'Settings',
  surveys: 'Surveys',

  profil: 'My profile',
  signout: 'Sign out'
}



// WEBPACK FOOTER //
// ./src/translations/en/menu.js